import {StepDatiGenPraticaComponent} from '../../step-dati-gen-pratica/step-dati-gen-pratica.component';
import {StepDatiGenFascicoloComponent} from '../../step-dati-gen-fascicolo/step-dati-gen-fascicolo.component';
import {StepPartiComponent} from "../../step-parti/step-parti.component";
import {StepSoggettiTerziComponent} from "../../step-soggetti-terzi/step-soggetti-terzi.component";
import {StepDatiEconomiciComponent} from "../../step-dati-economici/step-dati-economici.component";
import {StepAttiComponent} from "../../step-atti/step-atti.component";
import {StepAdempimentiComponent} from "../../step-adempimenti/step-adempimenti.component";
import {
  StepDocumentazioneAllegataComponent
} from "../../step-documentazione-allegata/step-documentazione-allegata.component";

export let stepMap: { numeroStep: number; component: any; buttonLabel?: string; customButtons?: boolean }[];
stepMap = [
  {
    numeroStep: 1,
    component: StepDatiGenPraticaComponent,
    customButtons: true
  },
  {
    numeroStep: 2,
    component: StepDatiGenFascicoloComponent,
    customButtons: true
  },
  {
    numeroStep: 3,
    component: StepPartiComponent,
    customButtons: true
  },
  {
    numeroStep: 4,
    component: StepSoggettiTerziComponent,
    customButtons: true
  },
  {
    numeroStep: 5,
    component: StepDatiEconomiciComponent,
    customButtons: true
  },
  {
    numeroStep: 6,
    component: StepAttiComponent,
    customButtons: true
  },
  {
    numeroStep: 7,
    component: StepAdempimentiComponent,
    customButtons: true
  },
  {
    numeroStep: 8,
    component: StepDocumentazioneAllegataComponent,
    customButtons: true
  },
];
